// Universal Problem Selector for All Knowledge Graph Samples
// Comprehensive list management for all sample types

import { hkdse2021Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2021Samples.js';
import { hkdse2021Samples_part2 } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2021Samples_part2.js';
import { hkdse2022Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2022Samples.js';
import { hkdse2022Samples_part2 } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2022Samples_part2.js';
import { hkdse2022Samples_part3 } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2022Samples_part3.js';
import { hkdse2022Samples_part4 } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2022Samples_part4.js';
import { hkdse2015Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2015Samples.js';
import { hkdse2015Samples_part2 } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2015Samples_part2.js';
import { hkdse2015Samples_part3 } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2015Samples_part3.js';
import { hkdse2015Samples_part4 } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2015Samples_part4.js';
import { hkdse2023Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2023Samples.js';
import { hkdse2024Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2024Samples.js';
import { hkdse2025Samples_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2025Samples_combined.js';
import { hkdse2020Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2020Samples.js';
import { hkdse2019Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2019Samples.js';
import { hkdse2018Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2018Samples.js';
import { hkdse2017Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2017Samples.js';
import { hkdse2016Samples } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2016Samples.js';
import { hkdse2016Samples_complete_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2016Samples_complete_combined.js';
import { hkdse2017Samples_complete_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2017Samples_complete_combined.js';
import { hkdse2018Samples_complete_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2018Samples_complete_combined.js';
import { hkdse2019Samples_complete_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2019Samples_complete_combined.js';
import { hkdse2020Samples_complete_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2020Samples_complete_combined.js';
import { hkdse2023Samples_complete_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2023Samples_complete_combined.js';
import { hkdse2024Samples_complete_combined } from '../data/knowledgeGraph/HKDSE_Paper1/hkdse2024Samples_complete_combined.js';

// Import all other knowledge graph samples
import { quadraticSamples } from '../data/knowledgeGraph/quadraticSamples.js';
import { circleGeometrySamples } from '../data/knowledgeGraph/circleGeometrySamples.js';
import { factorRemainderSamples } from '../data/knowledgeGraph/factorRemainderSamples.js';
import { probabilitySamples } from '../data/knowledgeGraph/probabilitySamples.js';
import { statisticsSamples } from '../data/knowledgeGraph/statisticsSamples.js';
import { trigonometrySamples } from '../data/knowledgeGraph/trigonometrySamples.js';
import { numberSystemSamples } from '../data/knowledgeGraph/numberSystemSamples.js';
import { identitiesSamples } from '../data/knowledgeGraph/identitiesSamples.js';
import { simultaneousEquationsSamples } from '../data/knowledgeGraph/simultaneousEquationsSamples.js';
import { geometrySamples } from '../data/knowledgeGraph/geometrySamples.js';
import { locusSamples } from '../data/knowledgeGraph/locusSamples.js';
import { percentagesSamples } from '../data/knowledgeGraph/percentagesSamples.js';
import { transformationSymmetrySamples } from '../data/knowledgeGraph/transformationSymmetrySamples.js';
import { exponentialLogarithmSamples } from '../data/knowledgeGraph/exponentialLogarithmSamples.js';
import { inequalitiesLinearProgrammingSamples } from '../data/knowledgeGraph/inequalitiesLinearProgrammingSamples.js';
import { ratesRatiosVariationsSamples } from '../data/knowledgeGraph/ratesRatiosVariationsSamples.js';
import { arithmeticGeometricSequencesSamples } from '../data/knowledgeGraph/arithmeticGeometricSequencesSamples.js';
import { mensurationSamples } from '../data/knowledgeGraph/mensurationSamples.js';
import { trigonometry2D3DSamples } from '../data/knowledgeGraph/trigonometry2D3DSamples.js';
import { straightLineEquationsSamples } from '../data/knowledgeGraph/straightLineEquationsSamples.js';

// HKDSE samples by year
const hkdseSamplesByYear = {
  hkdse2025: hkdse2025Samples_combined,
  hkdse2024: hkdse2024Samples_complete_combined,
  hkdse2023: hkdse2023Samples_complete_combined,
  hkdse2022: { 
    ...hkdse2022Samples, 
    ...hkdse2022Samples_part2, 
    ...hkdse2022Samples_part3, 
    ...hkdse2022Samples_part4 
  },
  hkdse2021: { ...hkdse2021Samples, ...hkdse2021Samples_part2 },
  hkdse2020: hkdse2020Samples_complete_combined,
  hkdse2019: hkdse2019Samples_complete_combined,
  hkdse2018: hkdse2018Samples_complete_combined,
  hkdse2017: hkdse2017Samples_complete_combined,
  hkdse2016: hkdse2016Samples_complete_combined,
  hkdse2015: { 
    ...hkdse2015Samples, 
    ...hkdse2015Samples_part2, 
    ...hkdse2015Samples_part3, 
    ...hkdse2015Samples_part4 
  }
};

// Topic samples
const topicSamples = {
  quadratic: quadraticSamples,
  circleGeometry: circleGeometrySamples,
  factorRemainder: factorRemainderSamples,
  probability: probabilitySamples,
  statistics: statisticsSamples,
  trigonometry: trigonometrySamples,
  numberSystem: numberSystemSamples,
  identities: identitiesSamples,
  simultaneousEquations: simultaneousEquationsSamples,
  geometry: geometrySamples,
  locus: locusSamples,
  percentages: percentagesSamples,
  transformationSymmetry: transformationSymmetrySamples,
  exponentialLogarithm: exponentialLogarithmSamples,
  inequalitiesLinearProgramming: inequalitiesLinearProgrammingSamples,
  ratesRatiosVariations: ratesRatiosVariationsSamples,
  arithmeticGeometricSequences: arithmeticGeometricSequencesSamples,
  mensuration: mensurationSamples,
  trigonometry2D3D: trigonometry2D3DSamples,
  straightLineEquations: straightLineEquationsSamples
};

// Helper function to flatten problems from a sample object
const flattenProblems = (sampleObject, sampleType, year = null) => {
  const problems = [];
  let problemNumber = 1;
  
  Object.values(sampleObject).forEach(category => {
    if (Array.isArray(category)) {
      category.forEach(problem => {
        problems.push({
          ...problem,
          problemNumber,
          sampleType,
          year,
          fullId: year ? `${year}_${problem.id}` : problem.id
        });
        problemNumber++;
      });
    }
  });
  
  return problems;
};

// Get all problems for a specific sample type
export const getProblemsBySampleType = (sampleType, year = null) => {
  if (year && hkdseSamplesByYear[year]) {
    const problems = flattenProblems(hkdseSamplesByYear[year], sampleType, year);
    return problems;
  }
  
  if (topicSamples[sampleType]) {
    return flattenProblems(topicSamples[sampleType], sampleType);
  }
  
  return [];
};

// Get problem by number for a specific sample type
export const getProblemByNumber = (sampleType, problemNumber, year = null) => {
  const problems = getProblemsBySampleType(sampleType, year);
  return problems.find(problem => problem.problemNumber === problemNumber);
};

// Get problem by ID
export const getProblemById = (problemId) => {
  // Check HKDSE samples first
  for (const [year, samples] of Object.entries(hkdseSamplesByYear)) {
    const problems = flattenProblems(samples, 'hkdse', year);
    const found = problems.find(p => p.id === problemId || p.fullId === problemId);
    if (found) return found;
  }
  
  // Check topic samples
  for (const [sampleType, samples] of Object.entries(topicSamples)) {
    const problems = flattenProblems(samples, sampleType);
    const found = problems.find(p => p.id === problemId);
    if (found) return found;
  }
  
  return null;
};

// Get formatted problem list for dropdown
export const getFormattedProblemList = (sampleType, year = null) => {
  const problems = getProblemsBySampleType(sampleType, year);
  return problems.map(problem => ({
    value: problem.problemNumber,
    label: `Problem ${problem.problemNumber}`,
    problem: problem
  }));
};

// Get current problem number from selected sample
export const getCurrentProblemNumber = (selectedSample) => {
  if (!selectedSample) return null;
  
  // Extract sample type and year from selected sample
  const sampleType = getSampleTypeFromId(selectedSample.id);
  const year = getYearFromId(selectedSample.id);
  
  const problems = getProblemsBySampleType(sampleType, year);
  const foundProblem = problems.find(problem => problem.id === selectedSample.id);
  return foundProblem ? foundProblem.problemNumber : null;
};

// Helper function to extract sample type from ID
const getSampleTypeFromId = (id) => {
  if (id.includes('hkdse')) return 'hkdse';
  if (id.includes('quad_')) return 'quadratic';
  if (id.includes('circle_')) return 'circleGeometry';
  if (id.includes('factor_')) return 'factorRemainder';
  if (id.includes('prob_')) return 'probability';
  if (id.includes('stats_')) return 'statistics';
  if (id.includes('trig_')) return 'trigonometry';
  if (id.includes('num_')) return 'numberSystem';
  if (id.includes('ident_')) return 'identities';
  if (id.includes('simul_')) return 'simultaneousEquations';
  if (id.includes('geo_')) return 'geometry';
  if (id.includes('locus_')) return 'locus';
  if (id.includes('percent_')) return 'percentages';
  if (id.includes('trans_')) return 'transformationSymmetry';
  if (id.includes('exp_')) return 'exponentialLogarithm';
  if (id.includes('ineq_')) return 'inequalitiesLinearProgramming';
  if (id.includes('rates_')) return 'ratesRatiosVariations';
  if (id.includes('seq_')) return 'arithmeticGeometricSequences';
  if (id.includes('mens_')) return 'mensuration';
  if (id.includes('trig3d_')) return 'trigonometry2D3D';
  if (id.includes('line_')) return 'straightLineEquations';
  
  return 'unknown';
};

// Helper function to extract year from ID
const getYearFromId = (id) => {
  const yearMatch = id.match(/hkdse(\d{4})/);
  return yearMatch ? `hkdse${yearMatch[1]}` : null;
};

// Get sample type and year from selected sample
export const getSampleInfo = (selectedSample) => {
  if (!selectedSample) return { sampleType: null, year: null };
  
  const sampleType = getSampleTypeFromId(selectedSample.id);
  const year = getYearFromId(selectedSample.id);
  
  return { sampleType, year };
};

// Check if sample supports problem dropdown
export const supportsProblemDropdown = (selectedSample) => {
  if (!selectedSample) return false;
  
  const { sampleType, year } = getSampleInfo(selectedSample);
  const problems = getProblemsBySampleType(sampleType, year);
  
  return problems.length > 1; // Only show dropdown if there are multiple problems
};

// Get dropdown title based on sample type and year
export const getDropdownTitle = (sampleType, year = null) => {
  if (year) {
    const yearNumber = year.replace('hkdse', '');
    return `HKDSE ${yearNumber} Paper 1 Problems`;
  }
  
  const titles = {
    quadratic: 'Quadratic Equations Problems',
    circleGeometry: 'Circle Geometry Problems',
    factorRemainder: 'Factor & Remainder Problems',
    probability: 'Probability Problems',
    statistics: 'Statistics Problems',
    trigonometry: 'Trigonometry Problems',
    numberSystem: 'Number System Problems',
    identities: 'Identities Problems',
    simultaneousEquations: 'Simultaneous Equations Problems',
    geometry: 'Geometry Problems',
    locus: 'Locus Problems',
    percentages: 'Percentages Problems',
    transformationSymmetry: 'Transformation & Symmetry Problems',
    exponentialLogarithm: 'Exponential & Logarithm Problems',
    inequalitiesLinearProgramming: 'Inequalities & Linear Programming Problems',
    ratesRatiosVariations: 'Rates, Ratios & Variations Problems',
    arithmeticGeometricSequences: 'Arithmetic & Geometric Sequences Problems',
    mensuration: 'Mensuration Problems',
    trigonometry2D3D: 'Trigonometry 2D & 3D Problems',
    straightLineEquations: 'Straight Line Equations Problems'
  };
  
  return titles[sampleType] || 'Problems';
}; 